import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Summary from "../../../components/yourAssets/donations/Summary";
import SuggestionBox from "../../../common/suggestionBox/SuggestionBox";

import { visited } from "../../../redux/slices/features/assetsOnBoardingSlice";
import { getAssetsDocuments } from "../../../redux/slices/yourAssets/AssetsDocumentsSlice";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
import { getAssetsTabDocument } from "../../../services/yourAssets/CommonServices";

const Donations = () => {
  let uID = getUserIdFromLocalStorage();
  const dispatch = useDispatch();
  const updates = useSelector((state) => state.auditTrail.updates);
  const tabStatuses = useSelector(
    (state) => state.assetsOnBoarding.assetsSuggestionBoxText
  );
  const reloadAssetsFiles = useSelector(
    (state) => state.assetsDocuments.documents.reload
  );
  const fetchDocumentList = async () => {
    const result = await getAssetsTabDocument(uID);
    if (result?.success) {
      dispatch(getAssetsDocuments(result.payLoad.items));
    }
  };
  useEffect(() => {
    fetchDocumentList();
  }, [reloadAssetsFiles]);
  return (
    <>
      <Summary updates={updates} />
      <SuggestionBox
        mainText={tabStatuses[6]}
        tabName="Donations"
        setVisited={visited}
      />
    </>
  );
};

export default Donations;
